module.exports = __webpack_public_path__ + "static/media/AEH.fec4972e.ttf";